import axiosInstance from '../../../utils/apiConfig';

const partnersApi = {
  // List partners with pagination and filters
  getAll: (params) =>
    axiosInstance
      .get('/b2b/partners', { params })
      .then((res) => res.data),

  // Get single partner details
  getById: (id) =>
    axiosInstance
      .get(`/b2b/partners/${id}`)
      .then((res) => res.data),

  // Create new partner
  create: (data) =>
    axiosInstance
      .post('/b2b/partners', data)
      .then((res) => res.data),

  // Update partner
  update: (id, data) =>
    axiosInstance
      .put(`/b2b/partners/${id}`, data)
      .then((res) => res.data),

  // Delete partner
  delete: (id) =>
    axiosInstance
      .delete(`/b2b/partners/${id}`)
      .then((res) => res.data),

  // Upload partner logo
  uploadLogo: (id, file) => {
    const formData = new FormData();
    formData.append('logo', file);

    return axiosInstance
      .post(`/b2b/partners/${id}/logo`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => res.data);
  },

  // Update partner status
  updateStatus: (id, status) =>
    axiosInstance
      .patch(`/b2b/partners/${id}/status`, { status })
      .then((res) => res.data),

  // Get partner statistics
  getStats: (id) =>
    axiosInstance
      .get(`/b2b/partners/${id}/stats`)
      .then((res) => res.data),

  // Get partner transactions
  getTransactions: (id, params) =>
    axiosInstance
      .get(`/b2b/partners/${id}/transactions`, { params })
      .then((res) => res.data),
};

export default partnersApi;